module.exports = __webpack_public_path__ + "static/media/00_360.9bfd9219.jpeg";